import React from 'react';
import { fullName } from '../lib/data';
import SummaryPoints from './SummaryPoints';
import { Button } from './ui/button';
import { Check, Bot, Building2 } from 'lucide-react';

// Human-in-the-loop close: on Approve, the agent's verified summary is written
// back into the practice-management system (Athena), completing the round trip
// — import from PM → verify via Stedi → post the summary back. This dialog is
// the evidence the front desk sees that the loop closed.
export default function CloseLoopDialog({ item, ts, onClose }) {
  if (!item) return null;
  const { patient, provider, payer, check } = item;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="absolute inset-0 bg-slate-900/30 backdrop-blur-[1px]" />
      <div className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl border border-slate-200 overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="p-5 border-b border-slate-100 flex items-center gap-3">
          <div className="h-9 w-9 rounded-full bg-emerald-50 flex items-center justify-center shrink-0"><Check className="h-5 w-5 text-emerald-600" /></div>
          <div>
            <div className="text-sm font-semibold text-slate-900">Verified — synced to Athena</div>
            <div className="text-xs text-slate-500">{fullName(patient)} · posted {ts}</div>
          </div>
        </div>
        <div className="p-5 space-y-3">
          <div className="text-[11px] uppercase tracking-wider text-violet-600 font-semibold flex items-center gap-1.5"><Bot className="h-3.5 w-3.5" />Agent-written summary</div>
          <SummaryPoints check={check} provider={provider} payer={payer} size="sm" />
          <div className="flex items-start gap-2 text-xs text-slate-500 bg-slate-50 border border-slate-200 rounded-lg px-3 py-2">
            <Building2 className="h-3.5 w-3.5 mt-0.5 shrink-0" />
            Written back to the practice-management record — your front desk sees this same verified summary in Athena, no manual re-keying.
          </div>
        </div>
        <div className="p-4 border-t border-slate-100 flex justify-end">
          <Button onClick={onClose} className="bg-brand-600 hover:bg-brand-700 text-white">Done</Button>
        </div>
      </div>
    </div>
  );
}
